import React, {useEffect, useState} from "react";
import {getLabCourseChapter} from "../../services/CourseRepository";
import {Link, useOutletContext, useParams} from "react-router-dom";
import {FaFlaskVial} from "react-icons/fa6";
import {CoursePage} from "../course/CoursePage";
import {routes} from "../../utils/Routes";
import {experiment_palette, getInterpolatedColor} from "../../components/color/Palettes";
import {IoHome} from "react-icons/io5";

export function LabCourse() {

    const params = useParams();
    const [chapter, setChapter] = useState(null);
    const [navigation, setNavigation] = useState([]);
    const {product} = useOutletContext()

    useEffect(() => {
        getLabCourseChapter(params.experiment).then(result => {
            setChapter(result.chapter)
            setNavigation(result.navigation)
        }).catch(e => console.log(e))
    }, [params.experiment]);

    if(chapter) {
        return (
            <div className={"row m-0"}>



                <div className={"col-3 d-flex flex-column bg-light sticky-sidebar p-0"}>
                            <Link to={routes.productHomeAbs(product.name)} className={"w-100 bg-dark ps-4 text-white py-3"}>
                                <IoHome size={28} className={"me-4"} />

                                <label>{product.name}</label>

                            </Link>


                    {
                        navigation.map((nav, idx) => (
                            <Link to={routes.labPageAbs(product.name, nav.name)} className={"ps-3 text-decoration-none text-dark  border-bottom py-3 d-flex "+ (nav.name === chapter.title ? " fw-bold border-2 ": "")}

                            >
                                <div style={{color:(nav.name !== chapter.title ? " #000000 " : getInterpolatedColor(experiment_palette,idx, 0, navigation.length))}}>
                                    <FaFlaskVial className={"mx-3 " } style={{color:getInterpolatedColor(experiment_palette,idx, 0, navigation.length)}} size={28} />
                                    <label className={""}>{nav.name}</label>
                                </div>
                            </Link>
                        ))
                    }
                </div>

                <div className={"col"}>

                    <CoursePage chapter={chapter} crumbs={[]} terms={[]}/>
                </div>
            </div>
        )

    }

}